import { createFileRoute } from '@tanstack/react-router'
import { FileDiff } from 'lucide-react'
import { ChangeDetailScreen } from '@/screens/improve/SCR-031-change-detail'

export const Route = createFileRoute('/_app/w/$ws/learning_/$changeId')({
  staticData: { screen: {"id":"SCR-031","title":"Change review","group":"Improve","perm":"learning.read","hidden":true,"description":"One proposed change: evidence, validation stages, canary and decision.", icon: FileDiff } },
  component: ChangeDetailScreen,
})
